import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import styles from './cross-product-sub-menu.styles.scss';

import '../../product-icon/product-icon';

export const CROSS_PRODUCT_SUB_MENU_TAG = 'spog-common-menu-cross-product-sub-menu' as const;

/**
 * Product's submenu item.
 */
@customElement(CROSS_PRODUCT_SUB_MENU_TAG)
export class SpogCrossProductSubMenu extends LitElement {
  static override styles = [styles];

  override render() {
    return html` <slot name="items"></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CROSS_PRODUCT_SUB_MENU_TAG]: SpogCrossProductSubMenu;
  }
}
